import React from 'react';
const EditViewTemplate=({container})=>{
    return (
        <div>
            <h1>{container.message()}</h1>
        </div>
    )
}
export default EditViewTemplate;